import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

type HubEventsUnavailableBannerProps = {
  isError: boolean;
};

export function HubEventsUnavailableBanner({
  isError,
}: HubEventsUnavailableBannerProps) {
  const { t } = useTranslation();
  if (!isError) return null;
  return (
    <Alert severity="warning" role="status" className="mb-2">
      {t('hubEventsUnavailable')}
    </Alert>
  );
}
